<template>
    <v-app v-bind:class="{cra}">
        <v-navigation-drawer v-if="$store.state.auth.user && deviceId"
                             dark
                             app
                             permanent
                             class="c-nav-drawer"
                             width="280"
                             :mini-variant="$vuetify.breakpoint.xs">

            <v-btn class="c-nav-drawer--account" :to="{name: 'account-settings', params: {deviceId}}" large outline flat
                   dark>Maya Hess
            </v-btn>
            <v-list>
                <v-list-tile dark>
                    <v-list-tile-content>
                        <v-list-tile-title class="subheading">Sprachnachrichten</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile :to="{name: 'voicemessage', params: {deviceId}}" exact dark active-class="nav-list-active">
                    <v-list-tile-action>
                        <i class="nav-icons caru-icons send"></i>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Nachricht senden</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile :to="{name: 'voicemessage-all', params: {deviceId}}" dark active-class="nav-list-active">
                    <v-list-tile-action>
                        <i class="nav-icons caru-icons all"></i>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Alle Nachrichten</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile :to="{name: 'voicemessage-recipient', params: {deviceId}}" dark
                             active-class="nav-list-active">
                    <v-list-tile-action>
                        <i class="nav-icons caru-icons recipient"></i>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Empfänger Info</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile dark class="c-mt-3">
                    <v-list-tile-content>
                        <v-list-tile-title class="subheading">Datenanalyse</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile :to="{name: 'analytics-remotecare', params: {deviceId}}" dark
                             active-class="nav-list-active">
                    <v-list-tile-action>
                        <i class="nav-icons caru-icons caru"></i>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title class="title">Notrufe</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile :to="{name: 'analytics-room', params: {deviceId}}" dark active-class="nav-list-active">
                    <v-list-tile-action>
                        <i class="nav-icons caru-icons room"></i>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title class="title">Raumklima</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
            <div class="c-nav-drawer--footer">
                <v-img ref="logo" @click="carulina = true" width="70px" :src="require('./assets/caru.svg')"
                       class="c-mb-1"></v-img>
                &copy; 2019 CARU AG
            </div>
        </v-navigation-drawer>
        <v-content fill-height>
            <router-view/>
        </v-content>
    </v-app>
</template>

<script>
import './styles/main.scss'
import { createNamespacedHelpers } from 'vuex'

const {mapState} = createNamespacedHelpers('device')

export default {
  name: 'App',
  data () {
    return {
      cra: false,
      craCnt: 0
    }
  },
  methods: {
    sc (ev) {
      try {
        this.cra = ev.target.parentNode === this.$refs.logo.$el && this.craCnt === 5
        this.craCnt = (this.craCnt + 1) % 6
      } catch (e) {
        this.cra = false
      }
    }
  },
  created () {
    document.addEventListener('click', this.sc)
    document.addEventListener('touchstart', this.sc)
  },
  destroyed () {
    document.removeEventListener('click', this.sc)
    document.removeEventListener('touchstart', this.sc)
  },
  computed: {
    ...mapState({
      deviceId: state => state.currentDevice ? state.currentDevice.device : null
    })
  },
}
</script>
<style lang="scss">
    @import "styles/vars";

    aside.theme--dark.v-navigation-drawer {
        background-color: $primary-color
    }

    .nav-icons.caru-icons {
        width: 19px;
        height: 19px;
    }

    .v-navigation-drawer .v-list {
        background: transparent;
    }

    .cra::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 99;
        background: #1AA766 url(assets/icons/caru_happy_w.svg) no-repeat center;
        background-size: contain;
    }
</style>
